import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './ToggleMenuButton.module.scss';

interface IToggleMenuButton {
  onClick: () => void;
  isMenuOpen?: boolean;
}

export const ToggleMenuButton = ({ isMenuOpen = false, onClick }: IToggleMenuButton) => {
  return (
    <button className={styles.toggleMenuButton} type="button" onClick={onClick}>
      {!isMenuOpen && <FontAwesomeIcon icon={faBars} />}
      {isMenuOpen && <FontAwesomeIcon icon={faTimes} />}
      <span className="sr-only">Open menu</span>
    </button>
  );
};
